import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Icon } from './Icon';

export function Section({ title, children }: { title?: string; children: ReactNode }) {
  return (
    <section className="mb-5">
      {title && (
        <h2 className="mb-2 px-2 text-xs font-bold tracking-wider text-muted uppercase">{title}</h2>
      )}
      <div className="card overflow-hidden">{children}</div>
    </section>
  );
}

export function Row({ label, value }: { label: ReactNode; value?: ReactNode }) {
  return (
    <div className="flex min-h-12 items-center justify-between gap-3 border-b border-line px-5 py-3 last:border-b-0">
      <span>{label}</span>
      {value !== undefined && <span className="text-right text-muted">{value}</span>}
    </div>
  );
}

/** Bo'lim ichidagi havola qatori: ikon + matn + chevron. */
export function LinkRow({
  to,
  icon,
  children,
}: {
  to: string;
  icon?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Link
      to={to}
      className="flex min-h-14 items-center gap-3 border-b border-line px-5 py-3 transition-colors last:border-b-0 active:bg-surface-2"
    >
      {icon && (
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-surface-2 text-lg">
          {icon}
        </span>
      )}
      <span className="min-w-0 flex-1 font-semibold">{children}</span>
      <Icon name="chevron" className="h-5 w-5 text-muted" />
    </Link>
  );
}
